import { createSelector } from '@reduxjs/toolkit'

const navbarSelector = state => state.navbar

export const selectedNavbarItemSelector = createSelector(
  navbarSelector,
  navbar => navbar.selectedItem
)
